import BaseApiManager from '../baseApiManager';
import { store } from '../../../redux/store';
import { showError } from '../../../redux/reducers/alerts/actions';

export default class TemplateApi extends BaseApiManager {
  static async getInstance() {
    if (!TemplateApi.instance) {
      TemplateApi.instance = new TemplateApi();
      TemplateApi._initPromise = TemplateApi.instance.init();
    }
    await TemplateApi._initPromise;
    return TemplateApi.instance;
  }

  async fetchTemplates(attempt = 0) {
    try {
      const res = await this.get(`user/${this.userId}/templates`);

      if (this.isSuccess(res.status)) {
        return res.data.templates;
      } else {
        store.dispatch(showError(true, `Server error when try to get templates. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchTemplates.bind(this), error, attempt);
    }
  }
}
